import { render, staticRenderFns } from "./JuridictionForm.vue?vue&type=template&id=2d0eb6ee&scoped=true"
import script from "./JuridictionForm.vue?vue&type=script&lang=js"
export * from "./JuridictionForm.vue?vue&type=script&lang=js"
import style0 from "./JuridictionForm.vue?vue&type=style&index=0&id=2d0eb6ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0eb6ee",
  null
  
)

export default component.exports